import { groq } from 'next-sanity'
import ErrorPage from 'next/error'
import { useRouter } from 'next/router'
import T from 'prop-types'
import React from 'react'

import { articleQuery } from '../../api'
import { getImageUrl } from '../../api/sanity'
import Article from '../../components/Article'
import NavList from '../../components/NavList'
import SanityPreview from '../../components/SanityPreview'
import SEO from '../../components/SEO'
import useColor from '../../hooks/useColor'
import { buildGetStaticPaths, buildGetStaticProps } from '../../lib/page'

const query = groq`
  *[_type == "article" && slug.current == $slug]${articleQuery} | order(_updatedAt desc)[0]
`

export default function Page({ preview, pageData, error, status, slug }) {
  const router = useRouter()
  useColor(null, status)

  if (error) {
    return <ErrorPage statusCode={error.statusCode} title={error.title} />
  }

  if (!router.isFallback && !pageData) {
    return <ErrorPage statusCode={404} />
  }

  return (
    <SanityPreview preview={preview} initialData={pageData} query={query} params={{ slug }}>
      {(article) => {
        return (
          <div>
            <SEO
              title={article?.title}
              description={article?.preamble}
              path={`artikkel/${article?.slug?.current}`}
              image={article?.ogImages?.facebook && getImageUrl(article?.ogImages?.facebook).url()}
              excludeFromSearch={article?.excludeFromSearch}
            />
            <NavList
              back={
                article?.backLink
                  ? { href: article?.backLink, title: 'Tilbake' }
                  : { title: 'Hjem', label: '/' }
              }
            />
            <Article {...article} />
          </div>
        )
      }}
    </SanityPreview>
  )
}

Page.propTypes = {
  status: T.string,
  pageData: T.shape({
    article: T.object,
  }).isRequired,
  slug: T.string.isRequired,
  preview: T.bool.isRequired,
  error: T.shape({
    statusCode: T.number.isRequired,
    title: T.string.isRequired,
    purpose: T.string,
  }),
}

export const getStaticProps = buildGetStaticProps(query)

export const getStaticPaths = buildGetStaticPaths('article')
